if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        // customize
        this.quantityInput = document.querySelector('.quantity__input');
        this.submitProductId = this.submitButton.getAttribute('data-product-id');
        this.submitProductLimitQuantity = this.submitButton.getAttribute('data-product-limit');
        
        this.isCurrentProductInCart();
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        // Display the values

                
        const addToCart = () => {
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading-overlay__spinner').classList.add('hidden');
              this.isCurrentProductInCart();
          });
        }

        // const submitProductQuantity = Number(formData.get('quantity'));
        
        // if(submitProductQuantity > 0) {
        //   const cartItems = await this.fetchCartItems();
        //   if(cartItems){
        //     const findedProduct = this.findProductInCart(cartItems, this.submitProductId);
        //     if(!findedProduct){
        //       if(submitProductQuantity > this.submitProductLimitQuantity) {
        //         this.handleErrorMessage('Submitted quantity data is above the allowed quantity. Allowed quantity: ' + this.submitProductLimitQuantity);
        //       }else{
        //         addToCart();
        //       }
        //     }else{
        //       if(findedProduct.quantity + submitProductQuantity > this.submitProductLimitQuantity){
        //         this.handleErrorMessage('Submitted quantity data is above the allowed quantity. Allowed quantity: ' + (findedProduct.quantity + submitProductQuantity - this.submitProductLimitQuantity));
        //       }else{
        //         addToCart();
        //       }
        //     }
        //   }else{
        //     if(submitProductQuantity > this.submitProductLimitQuantity) {
        //       this.handleErrorMessage('Submitted quantity data is above the allowed quantity. Allowed quantity: ' + this.submitProductLimitQuantity);
        //     }else{
        //       addToCart();
        //     }
        //   }
        // }
        const submitProductQuantity = Number(formData.get('quantity'));

        const isQuantityValid = (currentQuantity, limit) => currentQuantity <= limit;
        // const calculateExcessQuantity = (currentQuantity, limit) => currentQuantity - limit;
        // const handleQuantityError = (excessQuantity) => {
        //     this.handleErrorMessage(`Submitted quantity data is above the allowed quantity. Excess quantity: ${excessQuantity}`);
        // };

        const calculateAvailableQuantity = (currentQuantity, limit) => limit - currentQuantity;
        const handleQuantityError = (availableQuantity) => {
            this.handleErrorMessage(`Submitted quantity data is above the allowed quantity. Available quantity to add: ${availableQuantity}`);
        };  

        if (submitProductQuantity > 0) {
            const cartItems = await this.fetchCartItems();
            let totalQuantity = submitProductQuantity;

            if (cartItems) {
                const foundProduct = this.findProductInCart(cartItems, this.submitProductId);
                if (foundProduct) {
                    totalQuantity += foundProduct.quantity;
                }
            }

            if (!isQuantityValid(totalQuantity, this.submitProductLimitQuantity)) {
                // const excessQuantity = calculateExcessQuantity(totalQuantity, this.submitProductLimitQuantity);
                // handleQuantityError(excessQuantity);
                const availableQuantity = calculateAvailableQuantity(totalQuantity - submitProductQuantity, this.submitProductLimitQuantity);
                handleQuantityError(availableQuantity);
                this.updateQuantityInput(availableQuantity);
                this.changeSubmitButtonState('loaded');
            } else {
                addToCart();
            }
        }
      }

      updateQuantityInput(availableQuantity) {
        this.quantityInput.value = 1;
        this.quantityInput.setAttribute('max', availableQuantity.toString());
        this.quantityInput.setAttribute('data-max', availableQuantity.toString());
      };    

      changeSubmitButtonState(type) {
        switch (type) {
          case 'on':
            this.submitButton.removeAttribute('disabled');
            break;
          case 'off':
            this.submitButton.setAttribute('disabled', true);
            break;
          case 'loading':
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.classList.add('loading');
            this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
            break;
          case 'loaded':
            this.submitButton.setAttribute('aria-disabled', false);
            this.submitButton.classList.remove('loading');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            break;
        }
      }

      findProductInCart(cartItems, productId){
        return cartItems.find(cartItem => cartItem.product_id == Number(productId));
      }

      async isCurrentProductInCart(){
        const cartItems = await this.fetchCartItems();

        if(cartItems){
          const foundProduct = this.findProductInCart(cartItems, this.submitProductId);
          if(foundProduct) {
            let quantity = (this.submitProductLimitQuantity - foundProduct.quantity) <= 0 ? 1 : this.submitProductLimitQuantity - foundProduct.quantity;
            this.updateQuantityInput(quantity);
            if(foundProduct.quantity >= this.submitProductLimitQuantity){
              this.changeSubmitButtonState('off');
              this.handleErrorMessage('This product is already in the cart and has reached the allowed quantity. Please check the cart.');
              return;
            }
          }
        }
      }

      async fetchCart(){
        const response = await fetch(window.Shopify.routes.root + 'cart.js');
        return response.json();
      }

      async fetchCartItems(){
        const cartData = await this.fetchCart();
        const { items } = cartData;
        if(items.length > 0){
          return items.map(item => {
            return {
              product_id: item.product_id,
              quantity: item.quantity
            }
          })
        }
        return false;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
